import orderTranslationsHelper from "../../../../languages/order-translations.helper";
import {
  OrderUpdateErrorType,
  OrderUpdateNodeAlreadyCheckedOutError,
  OrderUpdatePassengersDoOverlapError,
  OrderUpdateResultTimingNotPossibleError,
  OrderUpdateTooLongRideError,
  OrderUpdateUnprocessableEntityErrorType,
} from "./order-update-error";

const createOrderUpdateNodeAlreadyCheckedOutError =
  (): OrderUpdateNodeAlreadyCheckedOutError => {
    const translation =
      orderTranslationsHelper.getEditTranslations().validation.errors.api;

    return {
      message: translation.nodeAlreadyCheckOut,
      params: {},
      type: OrderUpdateErrorType.NODE_ALREADY_CHECKED_OUT,
    };
  };

const createOrderUpdatePassengersDoOverlapError =
  (): OrderUpdatePassengersDoOverlapError => {
    const translation =
      orderTranslationsHelper.getEditTranslations().validation.errors.api;

    return {
      message: translation.passengersDoOverlap,
      params: {},
      type: OrderUpdateErrorType.PASSENGERS_DO_OVERLAP,
    };
  };

const createOrderUpdateResultTimingNotPossibleError =
  (): OrderUpdateResultTimingNotPossibleError => {
    const translation =
      orderTranslationsHelper.getEditTranslations().validation.errors.api;

    return {
      message: translation.resultTimingNotPossible,
      params: {},
      type: OrderUpdateErrorType.RESULT_TIMING_NOT_POSSIBLE,
    };
  };

const createOrderUpdateTooLongRideError = (): OrderUpdateTooLongRideError => {
  const translation = orderTranslationsHelper.getEditTranslations().validation;

  return {
    message: translation.errors.unprocessableEntity.givenTimeError,
    params: {},
    type: OrderUpdateUnprocessableEntityErrorType.TOO_LONG_RIDE,
  };
};

const orderUpdateErrorFactory = {
  createOrderUpdateNodeAlreadyCheckedOutError,
  createOrderUpdatePassengersDoOverlapError,
  createOrderUpdateResultTimingNotPossibleError,
  createOrderUpdateTooLongRideError,
};

export default orderUpdateErrorFactory;
